import { withDomains } from "../lib/domain";
import React, { useEffect, useState } from "react";
import { RESTExecutor } from "../lib/domain";
import { Link } from "react-router-dom";
import {
  Row,
  Space,
  Menu,
  Divider,
  Dropdown,
  message,
  Button,
  Tooltip,
  Modal,
  Tabs,
  Empty,
  Col,
} from "antd";
import { CustomButton } from "../components/forms/buttons";
import CompanyDetailCard from "../components/company_detail_card";
import {
  PlusOutlined,
  PlusCircleOutlined,
  SettingOutlined,
  LogoutOutlined,
  MailOutlined,
  CloseOutlined,
  ExclamationCircleOutlined,
  MoreOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { BASE_API_URL } from "../config";
import Text from "antd/lib/typography/Text";
import { getImageUrl } from "../util/ui_util";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { GridLayout, SearchIcon, WarnIcon } from "../assets/icons";
import { HomeTabs } from "../components/home-tabs";
import { TopHeader } from "../components/top-header";
import { ViewSwitch } from "../components/ViewSwitch";
import { CardTitle, GridView } from "./organization-list";
import { EmptyState } from "./empty-state";

let userName = "";
let imgSource = "";
const { confirm } = Modal;

const RequestList = ({ domains, authenticator, ...props }) => {
  const [loading, setLoading] = useState(true);
  let get_companies = RESTExecutor.list()
    .config({
      label: "namespace_register",
      params: { status: "Pending" },
    })
    .callbacks(
      (success) => {
        setLoading(false);
      },
      (error) => {
        console.log(error);
        error.error_message && message.error(error.error_message);
      }
    )
    .connect(domains.register);

  let delete_companies = RESTExecutor.post()
    .config({
      label: "cancel",
    })
    .callbacks(
      (success) => {
        get_companies.execute(true);
      },
      (error) => {
        error.error_message && message.error(error.error_message);
      }
    )
    .connect(domains.register);

  useEffect(() => {
    get_companies.execute(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // let companies_resp = get_companies.response();
  // let result = user_resp.result;

  // console.log(invite_resp.result, "hello");

  function showPromiseConfirm(title, ok) {
    confirm({
      title: title,
      content: "This action cannot be reversed",
      icon: <ExclamationCircleOutlined />,
      onOk() {
        ok();
      },
      onCancel() {},
    });
  }

  const onCancelRequest = ({ id }) => {
    function deleteCompany() {
      delete_companies.forId(id).execute(true);
    }
    showPromiseConfirm(
      "Do you really want to cancel your request?",
      deleteCompany
    );
  };
  let companies_resp = get_companies.response();
  if (companies_resp?.result?.length === 0) {
    return (
      <EmptyState
        title="No Pending Requests"
        description="Lets create your  organization together. Click the button below to get started"
        onButtonClick={() => {
          props.history.push({ pathname: `/new-company` });
        }}
      />
    );
  }

  return (
    <>
      <div className="comapny-card-menu-requests">
        <div className="company-card-menu-header">Organization Requests</div>
        <GridView data={companies_resp?.result} isLoading={loading}>
          {(companies_resp.result ?? []).map((item) => (
            <RequestCard data={item} onCancelRequest={onCancelRequest} />
          ))}
        </GridView>
      </div>
    </>
  );
};

const RequestCard = ({ data, onCancelRequest }) => {
  const subTitle = `${data?.slug}.tigg.app`;
  const title = data?.name;

  const avatar = getImageUrl(data)
    ? getImageUrl(data)
    : `https://ui-avatars.com/api/?name=${data?.name?.split(" ")[0]}+${
        data?.name?.split(" ")[1]
      }&background=393965&color=fff`;

  return (
    <Col xs={24} md={8} xl={6}>
      <div className="company_card border_layout">
        <div className="company_card__body" style={{ paddingTop: "16px" }}>
          <img className="border_element" src={avatar} alt={data?.slug} />
          <div
            style={{
              gap: "4px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              paddingLeft: "12px",
              paddingRight: "12px",
            }}
          >
          <CardTitle title={title} />
            <div
              style={{
                fontSize: "13px",
                fontWeight: "400",
                color: "var(--gray50)",
              }}
            >
              {subTitle}
            </div>
          </div>
        </div>
        <div style={{ width: "100%" }}>
          <Button
            style={{ width: "100%", borderRadius: "0px", height: "45px" }}
            type="text"
            danger
            onClick={() => {
              onCancelRequest({ id: data?.id });
            }}
            //   className="company-detail-action-button-cancel"
          >
            Cancel Request
          </Button>
        </div>
      </div>
    </Col>
  );
};

export default withDomains(
  RequestList,
  "user",
  "auth",
  "upgradeCredentials",
  "register"
);
